<div class="custom-snack-bar w-100">
  <div class="d-flex flex-row justify-content-between">
    <div class="snack-bar-icon">
      <mat-icon *ngIf="data.MessageType === 'error'">error</mat-icon>
      <mat-icon *ngIf="data.MessageType === 'success'">check_circle</mat-icon>
      <mat-icon *ngIf="data.MessageType === 'warning'">warning</mat-icon>
    </div>
    <div class="snack-bar-body col text-left">
      <h4 class="snack-bar-title" [innerHTML]="data.Title"></h4>
      <div class="snack-bar-content-body" [innerHTML]="data.Message">
      </div>
    </div>
    <div (click)="dismiss()" class="snack-bar-close">
      <mat-icon>close</mat-icon>
    </div>
  </div>
</div>